export default __webpack_public_path__ + "static/media/trifence-button.c4a4f714.svg";